var cell_phone = {};
module['exports'] = cell_phone;
cell_phone.formats = require("./formats");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de/cell_phone/index.js
// module id = 967
// module chunks = 1